<div class="wheel-history-modal" data-testid="wheel-history-modal-container">
  <div class="wheel-history-modal__header" data-testid="wheel-history-modal-header">
    <button
      class="wheel-history-modal__close-button"
      type="button"
      (click)="onCancel()"
      data-testid="wheel-history-modal-close-button"
      aria-label="Close modal"
    >
      <mat-icon>close</mat-icon>
    </button>

    <h2 class="wheel-history-modal__title" data-testid="wheel-history-modal-title">What's happening</h2>
  </div>

  <div class="wheel-history-modal__content" data-testid="wheel-history-modal-content">
    <canvas baseChart [data]="data" [options]="options" [type]="'line'"> </canvas>
  </div>
</div>
